"use strict";

var __extends = this && this.__extends || function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FindMeetingsForMyClassesEvents = exports.FindMeetingsById = exports.FindMeetingsFilter = exports.FindMeetingsStrategyEnum = void 0;
/** Алгоритмы поиска митингов */
var FindMeetingsStrategyEnum;
(function (FindMeetingsStrategyEnum) {
  /**
   * Алгоритм поиска митингов по ID
   *
   * @see FindMeetingsById
   */
  FindMeetingsStrategyEnum["by_id"] = "by_id";
  /**
   * Алгоритм поиска митингов для раздела /my-classes/events
   *
   * @see FindMeetingsForMyClassesEvents
   */
  FindMeetingsStrategyEnum["my_classes_events"] = "my_classes_events";
})(FindMeetingsStrategyEnum = exports.FindMeetingsStrategyEnum || (exports.FindMeetingsStrategyEnum = {}));
var FindMeetingsFilter = /** @class */function () {
  function FindMeetingsFilter() {}
  return FindMeetingsFilter;
}();
exports.FindMeetingsFilter = FindMeetingsFilter;
/** Параметры поиска митингов по ID */
var FindMeetingsById = /** @class */function (_super) {
  __extends(FindMeetingsById, _super);
  function FindMeetingsById(values) {
    var _this = _super.call(this) || this;
    _this.use = FindMeetingsStrategyEnum.by_id;
    if (!values) {
      return _this;
    }
    _this.id = values.id || [];
    return _this;
  }
  return FindMeetingsById;
}(FindMeetingsFilter);
exports.FindMeetingsById = FindMeetingsById;
/** Параметры поиска митингов для раздела /my-classes/events */
var FindMeetingsForMyClassesEvents = /** @class */function (_super) {
  __extends(FindMeetingsForMyClassesEvents, _super);
  function FindMeetingsForMyClassesEvents(values) {
    var _this = _super.call(this) || this;
    _this.use = FindMeetingsStrategyEnum.my_classes_events;
    if (!values) {
      return _this;
    }
    _this.group = values.group;
    return _this;
  }
  return FindMeetingsForMyClassesEvents;
}(FindMeetingsFilter);
exports.FindMeetingsForMyClassesEvents = FindMeetingsForMyClassesEvents;
